import "./style.scss";
import reportsIcon from "./reportsIcon.png";
import Button from "../common/button";
import {useNavigate} from "react-router-dom";

const NoReports = (props) => {
  const {
    schoolCount,
    totalSchools,
    showSampleReports,
    reportType,
    message,
  } = props;

  const sampleReports =
    <div className='no-reports-sample-reports-button'>
      <a href="/#/sample-reports" className='tes-button'>View Sample Reports</a>
    </div>

  return (
    <div className='no-reports-container'>
      <div className='no-reports-icon'>
        <img src={reportsIcon} alt='No Reports' className='no-reports-image'/>
      </div>
      <div className='no-reports-schoolcount'>
        {schoolCount} of {totalSchools} schools have {reportType} reports
      </div>
      <div className='no-reports-sample-reports'>
        {message}
        {showSampleReports ? sampleReports : ''}
        {showSampleReports}
      </div>
    </div>
  );
}

export default NoReports;